<template>
  <div class="basemap-control">
    <button class="mapboxgl-ctrl-icon basemap-control-button" type="button" title="Choose a basemap"></button>
    <div id="layers">
      <div>
        <input v-model="schoolDistrictLayer" id="school_district_layer" type="checkbox"><label for="school_district_layer">School District Boundaries</label>
      </div>
      <div>
        <input v-model="transitLayer" id="transit_layer" type="checkbox"><label for="transit_layer">Fixed Route Transit
        Routes</label>
      </div>
      <div v-if="transitLayer" style="display: inline-grid; grid-template-columns: 1fr 1fr; font-size: small">
        <div v-for="t in transitRouteLayer" :key="t['value']" style="margin-left: 15px; text-wrap: wrap; width: 200px;" >
          <span><font-awesome-icon :style="{'color': t['color']}" icon="route"></font-awesome-icon></span>
          <span style="margin-left: 5px;">{{ t['value'] }}</span>
        </div>
      </div>
      <div><input v-model="landUseContextLayer" id="land_use_context_layer" type="checkbox">
        <label for="land_use_context_layer">Land Use Context</label></div>
            <div v-if="landUseContextLayer" style="display: inline-grid; grid-template-columns: 1fr 1fr; font-size: small">
        <div v-for="t in landUseLayer" :key="t['value']" style="margin-left: 15px; text-wrap: wrap; width: 200px;" >
          <span><font-awesome-icon :style="{'color': t['color']}" icon="road"></font-awesome-icon></span>
          <span style="margin-left: 5px;">{{ t['value'] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayerList',
  props: ['data_table', 'mappedAmenity'],
  data: function () {
    return {
      transitLayer: false,
      landUseContextLayer: false,
      schoolDistrictLayer: false,
      transitRouteLayer: [{
        value: 'Ann Arbor Area Transportation Authority (AAATA)',
        color: '#F58231',
      }, {
        value: 'University of Michigan Transit',
        color: '#09284c',
      },{
        value: 'Blue Water Area Transit (BWAT)',
        color: '#4363D8',
      },{
        value: 'Detroit Department of Transportation (DDOT)',
        color: '#FFD007',
      },{
        value: 'Detroit People Mover',
        color: '#55FF00',
      },{
        value: 'Lake Erie Transit',
        color: '#911EB4',
      },{
        value: 'Michigan Flyer',
        color: '#FF0000',
      },{
        value: 'Regional Transit Authority Detroit Air Xpress (RTA DAX)',
        color: '#4CE600',
      },{
        value: 'Regional Transit Authority Detroit Ann Arbor Express (RTA D2A2)',
        color: '#730000',
      },{
        value: 'Regional Transit Authority QLINE (RTA)',
        color: '#FF00C5',
      },{
        value: 'Suburban Mobility Authority for Regional Transportation (SMART)',
        color: '#70A800',
      }],
      landUseLayer: [{
        value: 'Main Street',
        color: '#FF0000',
      },{
        value: 'Urban or Walkable Thoroughfare',
        color: '#FFAA00',
      },{
        value: 'Suburban Corridors',
        color: '#00C5FF',
      },{
        value: 'Small Town Hamlet or Village Commercial',
        color: '#FF00C5',
      },{
        value: 'Rural',
        color: '#4CE600',
      }],
    }
  },
  watch: {
    transitLayer: function () {
      this.$emit('transit-layer-change', this.transitLayer)
    },
    schoolDistrictLayer: function () {
      this.$emit('school-district-layer-change', this.schoolDistrictLayer)
    },
    landUseContextLayer: function () {
      this.$emit('land-use-context-layer-change', this.landUseContextLayer)
    },
    mappedAmenity: function () {
      if (this.mappedAmenity === 'fixed_route_bus') {
        this.transitLayer = true
      }
    },
    data_table: {
      immediate: true,
      handler: function () {
        this.transitLayer = this.data_table === 'transit_indicators_demographics_by_parcel';
      }
    }
  },
}
</script>

<style scoped>

.basemap-control-button {
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNTQuODQ5cHgiIGhlaWdodD0iNTQuODQ5cHgiIHZpZXdCb3g9IjAgMCA1NC44NDkgNTQuODQ5IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1NC44NDkgNTQuODQ5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PGc+PGc+PHBhdGggZD0iTTU0LjQ5NywzOS42MTRsLTEwLjM2My00LjQ5bC0xNC45MTcsNS45NjhjLTAuNTM3LDAuMjE0LTEuMTY1LDAuMzE5LTEuNzkzLDAuMzE5Yy0wLjYyNywwLTEuMjU0LTAuMTA0LTEuNzktMC4zMThsLTE0LjkyMS01Ljk2OEwwLjM1MSwzOS42MTRjLTAuNDcyLDAuMjAzLTAuNDY3LDAuNTI0LDAuMDEsMC43MTZMMjYuNTYsNTAuODFjMC40NzcsMC4xOTEsMS4yNTEsMC4xOTEsMS43MjksMEw1NC40ODgsNDAuMzNDNTQuOTY0LDQwLjEzOSw1NC45NjksMzkuODE3LDU0LjQ5NywzOS42MTR6Ii8+PHBhdGggZD0iTTU0LjQ5NywyNy41MTJsLTEwLjM2NC00LjQ5MWwtMTQuOTE2LDUuOTY2Yy0wLjUzNiwwLjIxNS0xLjE2NSwwLjMyMS0xLjc5MiwwLjMyMWMtMC42MjgsMC0xLjI1Ni0wLjEwNi0xLjc5My0wLjMyMWwtMTQuOTE4LTUuOTY2TDAuMzUxLDI3LjUxMmMtMC40NzIsMC4yMDMtMC40NjcsMC41MjMsMC4wMSwwLjcxNkwyNi41NiwzOC43MDZjMC40NzcsMC4xOSwxLjI1MSwwLjE5LDEuNzI5LDBsMjYuMTk5LTEwLjQ3OUM1NC45NjQsMjguMDM2LDU0Ljk2OSwyNy43MTYsNTQuNDk3LDI3LjUxMnoiLz48cGF0aCBkPSJNMC4zNjEsMTYuMTI1bDEzLjY2Miw1LjQ2NWwxMi41MzcsNS4wMTVjMC40NzcsMC4xOTEsMS4yNTEsMC4xOTEsMS43MjksMGwxMi41NDEtNS4wMTZsMTMuNjU4LTUuNDYzYzAuNDc3LTAuMTkxLDAuNDgtMC41MTEsMC4wMS0wLjcxNkwyOC4yNzcsNC4wNDhjLTAuNDcxLTAuMjA0LTEuMjM2LTAuMjA0LTEuNzA4LDBMMC4zNTEsMTUuNDFDLTAuMTIxLDE1LjYxNC0wLjExNiwxNS45MzUsMC4zNjEsMTYuMTI1eiIvPjwvZz48L2c+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjwvc3ZnPg==);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 70%;
}

#layers {
  display: none;
}

.basemap-control:hover {
  padding: 7px;
}

.basemap-control:hover #layers {
  display: inline-block;
}

.basemap-control:hover button {
  display: none;
}

input[type=checkbox]:disabled + label {
  color: #ccc;
}

</style>
